<ss-lib-page-layout>
  <div inner>

    <ng-container *ngIf="environment.internal">
      <div class="row pt-3 mb-4">
        <div class="col">
          <c11n-internal-callout variant="horizontal" [headingLevel]="2">
            <p class="c11n-text-md-bold">{{ content?.crewOnlyMessage || 'This page is for crew only. Clients cannot view this page.' }}</p>
          </c11n-internal-callout>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <div class="col-md-8 col-lg-8 m-auto">
        <div class="header_quit_container p-0 m-0">
          <header class="c11n-text-xxl-headline">
            {{ content?.headers?.reviewSubmit || 'Review & submit' }}
          </header>
          <c11n-button
            [size]="'small'"
            [labelText]="content?.buttons?.quit || 'Quit'"
            [variant]="'ghost'"
            [iconPosition]="'trailing'"
            (clickEvent)="closeButton()"
            iconName="remove"
            class="process-flow-pattern__quit-btn"
          >
          </c11n-button>
        </div>

        <ng-container>
          <div class="row">
            <div class="col pt-md-4 mb-3">
              <c11n-banner *ngIf="shouldShowWarningForDelete" [size]="errorConfig.size"
                           [headingText]="errorConfig.headingText"
                           [hasCloseControl]="false"
                           [variant]="errorConfig.variant">
                <div class="c11n-text-md--crop default__family-font">{{ errorConfig.body }}</div>
              </c11n-banner>
            </div>
          </div>
        </ng-container>

        <span tabindex="-1" class="confirmation__text mb-3">{{ content?.descriptions?.statusReview || 'Confirm your confirmation status changes before submitting.' }}</span>

        <div class="col-md-12 c11n-grid-story__cell">
          <c11n-spinner *ngIf="isLoaderIndicator" class="spinner-on-screen" size="medium"
                        colorMode="on-light" spinnerStatus="Loading...">
          </c11n-spinner>
          <div class="for-scroll" tabindex="0" role="region"
               aria-label="selected confirmations" #contentElement data-id='scrollable_table'>
            <table id="confirmations-list-table"
                   class="mt-3 c11n-table c11n-table--small c11n-table--sticky-th-horizontal c11n-table--sticky-th-vertical"
                   data-cy="recent-trans-table" data-vui-sticky-elements-parent="">
              <thead confirmsStickyHeader>
              <tr class="c11n-table__tr">
                <th scope="col" class="c11n-table__thead-th sticky-left" [attr.aria-label]="content?.tableLabels?.date || 'Date'">
                  {{ content?.tableLabels?.date || 'Date' }}
                </th>
                <!--responsivedownload class is For Mobile view-->
                <th scope="col" class="c11n-table__thead-th c11n-table__thead-th--align-left">
                              <span role="document"
                                    [attr.aria-label]="(content?.tableLabels?.confirmation || 'Confirmation').toLowerCase()">
                                 {{ content?.tableLabels?.confirmation || 'Confirmation' }} </span>
                </th>
                <th scope="col" class="c11n-table__thead-th c11n-table__thead-th--align-left">
                              <span role="document"
                                    [attr.aria-label]="(content?.tableLabels?.status || 'Status').toLowerCase()">
                                 {{ content?.tableLabels?.status || 'Status' }} </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let confirms of changedConfirms$ ; let i = index">
                <tr class="c11n-table__tr" [ngClass]="isDeleteStatus(confirms)">
                  <td class="recent-transaction-type c11n-table__td c11n-table__td--align-left sticky-left">
                    {{ confirms.endDate }}
                  </td>
                  <td
                    class="recent-transaction-type c11n-table__td c11n-table__td--align-left">
                    {{ confirms.confirmationDescription}}
                  </td>
                  <!--responsivedownload class is For Mobile view-->
                  <td
                    class="recent-transaction-type c11n-table__td c11n-table__td--align-left">
                    {{ confirms.newStatus | titlecase}}
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-5 mb-5">
          <c11n-button buttonType="button" [size]="'medium'" variant="secondary" [labelText]="content?.buttons?.back || 'Back'"
                       (clickEvent)="edit()"
                       iconName="" colorMode="on-light" class="pe-3"></c11n-button>

          <c11n-button [isInvalid]="false"
                       buttonType="submit" [size]="'medium'" variant="primary"
                       [labelText]="content?.buttons?.submit || 'Submit'"
                       (clickEvent)="finalSubmit(changedConfirms$, $event)" iconName="" colorMode="on-light">
          </c11n-button>
        </div>
      </div>
    </div>
  </div>
</ss-lib-page-layout>

<c11n-modal-dialog (primaryClick)="closeButton()" (closeEvent)='closeButton()'
                   [modalId]="'add-success-modal'" [variant]="'success'"
                   [headingText]="content?.statusReviewMessages?.statusUpdatedHeading || 'Confirmation status updated'" [hideBody]="false" [primaryButtonLabel]="content?.buttons?.ok || 'OK'"
                   #successModal>
  <div c11n-modal-dialog-body c11n-modal-dialog-custom-buttons>
  </div>
</c11n-modal-dialog>

<c11n-modal-dialog (primaryClick)="closeButton()" (closeEvent)='closeButton()'
                   [modalId]="'add-error-modal'" [variant]="'error'"
                   [headingText]="'Unable to perform action'" [primaryButtonLabel]="content?.buttons?.ok || 'OK'"
                   #errorModal>
  <p>{{ errorMessage }}. Please try again.</p>
</c11n-modal-dialog>